export const AnalyticsRoutes = {
	Local: 'http://localhost:1200',
	LocalLive: 'http://localhost:1210',
	Cypress: 'http://localhost:1220',
	Test: 'https://analytics.stage.agilox.net',
	Beta: 'https://analytics.beta.agilox.net',
	Live: 'https://analytics.agilox.net',
	Stage: 'https://analytics.stage.agilox.net',
} as const;
